import { createAction, props } from '@ngrx/store';
import { IProfile } from '@appShared/interfaces/[Interface-based]/profile.interface';

const pageLevelEventPrefix = '[Shareholder Page Action]';

export const loadShareholders = createAction(
  `${pageLevelEventPrefix} Load Shareholders`,
  props<{ includeRepurchaseOptionExecuted: boolean }>()
);

export const setShareholderSearchFilter = createAction(
  `${pageLevelEventPrefix} Set Shareholders Search Filter`,
  props<{ searchFilter: string }>()
);
